module.exports = __webpack_public_path__ + "static/media/VueIcon.be6dd04f.svg";